import { createModal } from '/@/core/elements/modal'
import { type FullInvoice } from '/@/common/invoices/types'

export interface InvoiceAmountModalData {
  invoice: FullInvoice | null
  mode: 'update' | 'refund'
  onSubmit: (() => void) | null
}

const { api, component } = createModal<InvoiceAmountModalData>(
  'InvoiceAmountModal',
  () => import('./InvoiceAmountModal.vue'),
  {
    invoice: null,
    mode: 'update',
    onSubmit: null,
  },
)

export const useInvoiceAmountModal = api
export default component
